const doc = [({"en":({"js":({"admin":({"people":({"table":({"contact_id":"Contact ID"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;